

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

var _squid = require('squid');

var _index = require('xo-models/src/credit/index');

var _index2 = require('xo-models/src/checkout/index');

var _directive = require('xo-page-components/src/header/directive');

var _cycoExitFactory = require('xo-page-components/src/footer/cycoExitFactory');

require('./faq/directive');

var _xoCreditBannerUtils = require('../lib/xo-credit-banner-utils');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
    tag: 'xo-choose-credit-offer',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            var authModel = _auth.$AuthModel.instance();
            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.props.token);
            var shouldRetrieveSession =
            // See comment in route.js
            _uiRouter.$stateParams.populateSession ||
            // checkoutSession should be retrieved in Hermes as long as it is not a guest session
            authModel.logged_in;

            return {
                auth: authModel.retrieve()['catch'](_angular.noop),
                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve({
                    params: {
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })['catch'](_angular.noop),
                checkoutSession: shouldRetrieveSession ? checkoutSession.retrieve()['catch'](_angular.noop) : checkoutSession,
                payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                creditOptions: _index.$CreditInstallmentModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                flowEligibility: _index2.$FlowEligibilityModel.instance(this.props.token).retrieve()['catch'](_angular.noop)
            };
        },
        locale: function locale() {
            // see xo-landing/route.js in hermesnodeweb repo for locale override
            var locale = {
                merchantCountry: this.checkoutAppData.get('merchant.merchant_country'),
                buyerCountry: _squid.$locale.country
            };

            _logger.$logger.info('cyco_locale', locale);
            return locale;
        }
    },
    actions: {
        redirectToReview: function redirectToReview() {
            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');
            this.creditDataModel.payInFull = true;
            _logger.$logger.info('checkout_fpti', {
                from: 'CHOOSE_CREDIT_OFFER',
                to: 'process_pay_in_full'
            });
            if (!this.models.auth.logged_in) {
                _uiRouter.$state.go('checkout.login');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        },
        toggleSacOffer: function toggleSacOffer(isExtended) {
            this.sacExtended = isExtended ? false : true;
        },
        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
            this.installmentExtended = isExtended ? false : true;
        },
        toggleFAQ: function toggleFAQ(index) {
            this.faqExtended[index] = !this.faqExtended[index];
        },
        toggleAllFAQ: function toggleAllFAQ() {
            this.allFaqExtended = !this.allFaqExtended;
            var newState = false; // closed

            if (this.allFaqExtended) {
                this.toggleText = (0, _squid.$renderContent)('FAQ.closeAllSections');
                newState = true; // opened
            } else {
                this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');
                newState = false; // closed
            }

            for (var i in this.faqExtended) {
                this.faqExtended[i] = newState;
            }
        },
        getCreditFinancingCodes: function getCreditFinancingCodes() {
            var sacOffer = this.offers.getNiOffer();
            var financingCodes = '';

            if (this.creditOffers && this.installmentCount) {
                this.creditOffers.installment_options.forEach(function (installment) {
                    financingCodes += installment.financingCode;
                    financingCodes += ',';
                });
            }

            if (sacOffer) {
                financingCodes += sacOffer.financingCode;
            }

            return financingCodes;
        },
        getInstallmentContent: function getInstallmentContent() {
            var contentKey = 'chooseCreditOption.singleInstallmentDescription';

            if (this.installmentCount > 1) {
                if (this.creditOffers.installment_options.find(function (installment) {
                    return installment.apr === '0.00';
                })) {
                    contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
                } else {
                    contentKey = 'chooseCreditOption.installmentDescription2';
                }
            }
            return contentKey;
        },
        handleRedirect: function handleRedirect() {
            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
            var isBuyerSet = this.fundingInstruments;
            var isSignUpFlow = this.creditDataModel.isCreditSignup();
            var isChangeInstallment = this.creditDataModel.isChangeStatus();
            var is2ndButton = this.models.checkoutAppData.is_second_button_txn;

            var isBillingNoPurchase = this.checkoutCart.isBillingNoPurchase();

            $('body').removeClass('CYCOPage');
            _directive.$SetHeaderText.setText('');

            if (creditMemberType === 'existingMember') {
                // When user selects an offer, PPC should be set as the selected FI
                if (isBillingNoPurchase) {
                    var fpList = this.models.checkoutSession.get('futurePaymentInstruments');
                    var bml = fpList.find(function (fp) {
                        return fp.type === 'BILL_ME_LATER';
                    });

                    return this.models.checkoutSession.action('setStickyFI', {
                        data: {
                            instrument_id: bml.instrument_id
                        },
                        success: function success() {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else {
                    var fiList = this.models.checkoutSession.get('fundingOptions.instruments');
                    var fundingSource = _squid.$util.find(fiList, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });

                    return this.models.checkoutSession.fundingOptions.action('select', {
                        resultModel: this.models.checkoutSession,
                        data: {
                            planId: fundingSource.planId
                        },
                        success: function success(result) {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                }
            } else if (isBuyerSet || isSignUpFlow && isChangeInstallment || is2ndButton || this.locale.buyerCountry === 'DE') {
                _uiRouter.$state.go('checkout.redirectToCape');
            } else {
                _uiRouter.$state.go('checkout.login');
            }
        },
        onSelect: function onSelect(index) {
            var _this = this;

            this.creditDataModel.setSelectedCYCOOffer(true);

            if (index === 'CORE') {
                if (this.models.creditOptions && this.models.creditOptions.creditType) {
                    delete this.models.creditOptions.creditType;
                }
                _logger.$logger.info('checkout_fpti', { 'credit_type': 'CORE' });
                this.actions.handleRedirect();
            } else {
                var isPPCReuse = this.isCreditInWallet;
                var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
                var param = {
                    'financing_code': selectedOffer.financingCode,
                    'apr': selectedOffer.apr,
                    'term': selectedOffer.term,
                    'credit_type': selectedOffer.creditType,
                    'paypal_subsidy': selectedOffer.paypalSubsidy,
                    'credit_installment_integration_type': this.models.checkoutAppData.isSecondButton() ? 'SECOND_BUTTON' : undefined
                };

                if (index !== 'SAC') {
                    param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
                    param.total_cost = selectedOffer.totalPayment.value;
                    param.total_interest = selectedOffer.totalInterest.value;
                    param.monthly_payment = selectedOffer.monthlyPayment.value;
                    param.currency = selectedOffer.monthlyPayment.currency;
                }

                return this.models.creditOptions.action('select', {
                    data: param,
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', {
                            'is_ppc_reuse': isPPCReuse ? '1' : '0',
                            'credit_type': selectedOffer.creditType,
                            'financing_code_selected': selectedOffer.financingCode
                        });
                        _this.actions.handleRedirect();
                    }
                });
            }
        },
        showExitSurvey: function showExitSurvey() {
            _cycoExitFactory.$cycoExitFactory.showExitSurvey();
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutAppData = _index2.$CheckoutAppDataModel.instance(this.props.token);
            this.checkoutCart = _index2.$CheckoutCartModel.instance(this.props.token);
            this.creditDataModel = _index.$CreditDataModel.instance(this.props.token);
            this.faqExtended = [false, false, false];
            this.allFaqExtended = false;
            $('.paypalHeaderWrapper').addClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
            $('body').addClass('CYCOPage');
            _directive.$SetHeaderText.setText('chooseCreditOption.offerHeading');
            _cycoExitFactory.$cycoExitFactory.cycoEnter(this.checkoutAppData.get('merchant.merchant_country'));
        },
        exit: function exit() {
            _cycoExitFactory.$cycoExitFactory.cycoExit();
        },
        populate: function populate() {
            var _this2 = this;

            var self = this;
            var MIN_AMOUNT = '$99';

            if (this.locale.buyerCountry === 'GB') {
                MIN_AMOUNT = '£99';
            } else if (this.locale.buyerCountry === 'DE') {
                MIN_AMOUNT = '€99';
            }

            this.aprContent = _squid.$config.representativeExampleGB;

            this.offers = new _index.$CreditInstallmentOptionsModel({
                id: this.props.token,
                payee: this.models.payee,
                checkoutCart: this.models.checkoutCart,
                checkoutAppData: this.models.checkoutAppData,
                isMemberCredit: true
            });

            this.isBillingNoPurchase = this.checkoutCart.isBillingNoPurchase();

            if (this.isBillingNoPurchase) {
                this.fundingInstruments = this.models.checkoutSession.get('futurePaymentInstruments');
            } else {
                this.fundingInstruments = this.models.checkoutSession.get('fundingOptions.instruments');
            }

            if (this.models.auth.logged_in && this.fundingInstruments) {
                this.models.checkoutSession.retrieve();
            }

            if (this.isBillingNoPurchase) {
                this.isCreditInWallet = this.models.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            this.toggleText = (0, _squid.$renderContent)('FAQ.openAllSections');

            // Use templateVars when the content is required to fill in the properties from locale files.
            this.templateVars = {
                merchantName: this.models.checkoutAppData.get('merchant.brand_name'),
                amount: this.checkoutCart.get('purchase.amounts.total.amount_formatted'),
                minAmount: MIN_AMOUNT,
                seeTermsUrl: undefined
            };

            // Call SSOT to determine installment options
            this.offers.save({
                cache: true,
                success: function success(result) {
                    _this2.creditOffers = _this2.offers.getInstallmentOffers();
                    _this2.creditOfferDetails = _this2.creditOffers && _this2.creditOffers.installment_options;
                    _this2.installmentCount = _this2.offers.getInstallmentCount();
                    _this2.creditDataModel.setInstallmentCount(_this2.offers.getInstallmentCount());
                    var installmentOfferDetailsArray = _this2.creditOfferDetails ? _this2.creditOfferDetails.map(function (item) {
                        return item.financingCode;
                    }) : [];

                    var hasThreeMonthInstallment = _xoCreditBannerUtils.$xoCreditBannerUtils.hasThreeMonthInstallments(installmentOfferDetailsArray);

                    // Throw error if its a three month financing code on old CYCO page
                    if (hasThreeMonthInstallment) {
                        _logger.$logger.info('CYCO: ssot call returned three month financing code: ' + installmentOfferDetailsArray);
                        return _angular.$q.reject();
                    }

                    if (result && result.conversion_info && result.conversion_info.converted_transaction_amount) {
                        _logger.$logger.info('CYCO: Setting Cross Country cart_amount and cart_currency');
                        _this2.creditDataModel.setCartAmountAndCurrency({
                            cart_amount: result.conversion_info.converted_transaction_amount.value,
                            cart_currency: result.conversion_info.converted_transaction_amount.currency_code
                        });
                    }
                },
                error: function error(_error) {
                    _logger.$logger.info('CYCO: ssot call returned error: ' + _error);
                    return _angular.$q.reject(_error);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        _logger.$logger.info('CYCO: ssot call returned contingency: ' + name);
                        return _angular.$q.reject(err);
                    }
                }
            }).then(function (results) {
                _this2.installmentsPresent = _this2.offers.getInstallmentOptionsPresent();

                // Logging when Both BA and EZP enabled
                if (_this2.models.checkoutCart.isBilling() && _this2.installmentsPresent) {
                    _logger.$logger.info('CYCO: Merchant ' + _this2.templateVars.merchantName + ' in ' + _this2.locale.merchantCountry + ' has both BA and EZP enabled');
                }

                _this2.installmentCount = _this2.offers.getInstallmentCount();
                _this2.templateVars.seeTermsUrl = _this2.creditOffers ? (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this2.creditOffers.terms_param : undefined;

                if (_this2.creditOffers) {
                    _logger.$logger.info('checkout_fpti', {
                        'financing_code_offered': _this2.actions.getCreditFinancingCodes()
                    });
                }
                _this2.installmentContentKey = _this2.actions.getInstallmentContent();

                /**
                 * installmentSectionExtendedByDefault: Only applicable to GB and DE, this variable is true when by deafult
                 * we want installments section to be extended.
                 **/
                _this2.installmentSectionExtendedByDefault = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showInstallmentOfferOnly: Only applicable to GB and DE, this variable is true when installments
                 * are available and its second button flow.
                 * Intention behind it is to not confuse user when merchant is willing to provide installments.
                 * Product/business is reviewing this and we might start showing both NI and INST in this case.
                 **/
                _this2.showInstallmentOfferOnly = (_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn;

                /**
                 * showNIOfferOnly:
                 * US: showNIOfferOnly will always be false for US. In US there is no scenario to show only NI/SAC offer
                 * on CYCO. If its just NI/SAC offer for user, then CYCO page should not be shown in US.
                 * GB: showNIOfferOnly is true in GB when only NI offer is available. In this case, user is shown only NI
                 * offer on CYCO. This is just to show all the details again to user. Product/Business are
                 * exploring this scenario to probably skip showing CYCO in this case.
                 **/
                _this2.showNIOfferOnly = false;
                if ((_this2.locale.buyerCountry === 'GB' || _this2.locale.buyerCountry === 'DE') && _this2.installmentsPresent && !_this2.models.checkoutAppData.is_second_button_txn && !(_this2.models.checkoutSession && _this2.models.checkoutSession.creditInstallmentOffer)) {
                    _this2.showNIOfferOnly = true;
                }

                /**
                 * showNoInterestSection:
                 * US: This should always be true for US.
                 * GB 1st button: This should be always true for 1st button scenarios.
                 * GB 2nd button: This should be false when installments are available, true otherwise.
                 * GB BA Flows: There is no merchant with both BA and INST configured. If that happens,
                 * there should be a story to update code as desired.
                 **/
                _this2.showNoInterestSection = _this2.locale.buyerCountry === 'DE' ? !_this2.showInstallmentOfferOnly : _this2.creditOffers && _this2.creditOffers.sac_options;

                // For converting SAC content to NI in US for Asset light
                // this.showNIInsteadOfSACInUS = this.locale.buyerCountry === 'US' && this.creditOffers.sac_options
                // && (this.creditOffers.sac_options.creditType === 'NI');

                // Dynamic APR in installment offer description
                var minOfferedAPR = 100;
                _this2.templateVars.minOfferedAPR = '0';
                if (_this2.installmentsPresent) {
                    _this2.creditOffers.installment_options.forEach(function (offer, key) {
                        var apr = parseFloat(offer.apr);

                        if (isNaN(apr)) {
                            this.incorrectAPR = true;
                        } else {
                            minOfferedAPR = apr < minOfferedAPR ? apr : minOfferedAPR;
                        }
                    });
                    _this2.templateVars.minOfferedAPR = String(minOfferedAPR);
                }
            })['catch'](function (error) {
                // if PPC 2nd button, redirect to generic error
                // else (if 1st button), redirect to review
                if (_this2.models.checkoutAppData.is_second_button_txn) {
                    _uiRouter.$state.go('checkout.genericError');
                } else {
                    _this2.models.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['paymentMethod.cycoSsotWarning']
                    };
                    return self.actions.redirectToReview();
                }
            });
        }
    }

});


_uiRouter.$state;

_uiRouter.$stateParams;

_angular.$q;

_angular.noop;

_logger.$logger;

_auth.$AuthModel;

_squid.$Component;

_squid.$locale;

_squid.$util;

_squid.$feature;

_squid.$renderContent;

_squid.$config;

_index.$CreditInstallmentModel;

_index.$CreditDataModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutAppDataModel;

_index2.$FlowEligibilityModel;

_index.$CreditInstallmentOptionsModel;

_directive.$SetHeaderText;

_cycoExitFactory.$cycoExitFactory;

_xoCreditBannerUtils.$xoCreditBannerUtils;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/choose-credit-offer/directive.js
// module id = ../node_modules/xo-credit-components/src/choose-credit-offer/directive.js
// module chunks = 0